import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { ApiListing } from 'api/types/ApiListing';
import { ApiUnpublishedListing } from 'api/types/ApiUnpublishedListing';
import { ApiImportedListing } from 'api/volops';
import { SliceActions } from 'types/SliceActions';

// Types

export type MainStoreListingsState = {
  byId: Record<
    string,
    {
      listing:
        | ApiListing
        | ApiUnpublishedListing
        | ApiImportedListing
        | undefined;
      isFetching?: boolean;
    }
  >;
};

// Reducer

const listingsSlice = createSlice({
  name: 'listings',
  initialState: { byId: {} } as MainStoreListingsState,
  reducers: {
    fetchListingRequest: (
      state,
      action: PayloadAction<{ listingId: string }>,
    ) => {
      const { listingId } = action.payload;
      state.byId[listingId] = { listing: undefined, isFetching: true };
    },
    fetchListingSuccess: (
      state,
      action: PayloadAction<{ listing: ApiListing }>,
    ) => {
      const { listing } = action.payload;
      state.byId[listing.id] = { listing, isFetching: false };
    },
  },
});

export const listingsReducer = listingsSlice.reducer;

const {
  actions: { fetchListingRequest, fetchListingSuccess },
} = listingsSlice;

export { fetchListingRequest, fetchListingSuccess };

export type MainStoreListingsAction = SliceActions<
  typeof listingsSlice.actions
>;
